//新闻详情页
<template>
  <div>
    <!--<common-header />-->
    <div class="information-center">
      <div v-if="$i18n.locale === 'en_US'">
        {{ information.enTitle }}
      </div>
      <div v-else>
        {{ information.title }}
      </div>
      <div>
        <div>{{ $t("information.releaseTime") }}：{{ information.releaseTime }}</div>
        <div>{{ $t("information.readNum") }}：{{ information.readNumber }}</div>
      </div>
      <div class="htmlContent">
        <div
          v-if="$i18n.locale === 'en_US'"
          v-html="information.enContent"
        />
        <div
          v-else
          v-html="information.content"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import CommonHeader from "@/components/CommonHeader";
  export default {
    name: "JdNewsDetail",
    components: {
      // CommonHeader
    },
    data() {
      return {
        // 新闻ID
        informationId: this.$route.query.informationId,
        // 新闻实体
        information: {},
      }
    },
    created() {
      this.getInformationById();
    },
    methods: {
      getInformationById() {
        let url = `/item/information/getInformationById?id=${this.informationId}`;
        this.$doGet(url).then((res) => {
          if (res.code == 200) {
            this.information = res.data;
          }
        }).catch((err) => {
          console.log(err);
        })
      },
    },
  }
</script>

<style scoped lang="less">
  /**:消息内容 */
  .information-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
    margin: 18px auto;
  }
  .information-center > div:nth-child(1) {
    height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #222222;
    line-height: 24px;
    margin-bottom: 8px;
  }
  .information-center > div:nth-child(2) {
    display: flex;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 24px;
    margin-bottom: 18px;
  }
  .information-center > div:nth-child(2) > div:nth-child(1) {
    margin-right: 32px;
  }
  .htmlContent {
    margin-bottom: 100px;
    padding: 0 110px;
  }
</style>